import { render, staticRenderFns } from "./dynamic-ledger.vue?vue&type=template&id=10150814&"
import script from "./dynamic-ledger.js?vue&type=script&lang=js&"
export * from "./dynamic-ledger.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports